import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { QuickWinSection } from '../components/QuickWinSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-main font-sans text-body" data-id="element-256">
      {/* Navigation / Logo */}
      <nav className="absolute top-0 left-0 w-full p-6 z-50" data-id="element-257">
        <div className="max-w-7xl mx-auto flex justify-center items-center" data-id="element-258">
          <div className="text-xl font-serif font-bold tracking-wider text-title" data-id="element-259">
            MÉTODO FACELESS<span className="text-accent" data-id="element-260">.</span>
          </div>
        </div>
      </nav>

      <main data-id="element-261">
        <HeroSection data-id="element-262" />
        <ProblemSection data-id="element-263" />
        <SolutionSection data-id="element-264" />
        <WhatInsideSection data-id="element-265" />
        <QuickWinSection data-id="element-266" />
        <TestimonialsSection data-id="element-267" />
        <PricingSection data-id="element-268" />
        <FAQSection data-id="element-269" />
        <CTASection data-id="element-270" />
      </main>
      <Footer data-id="element-271" />
    </div>;
}